"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCustomerIdentified = void 0;
const isLogged_1 = require("../isLogged");
const token_1 = require("./token");
function isCustomerIdentified() {
    const logged = (0, isLogged_1.isLogged)();
    if (logged)
        return true;
    const customerToken = (0, token_1.getCheckoutCustomerIdFromStorage)();
    return !!customerToken;
}
exports.isCustomerIdentified = isCustomerIdentified;
